import Vue from 'vue';

function capitalize(value: string) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
}

Vue.filter('capitalize', capitalize);

export default capitalize;
